'use strict';

bbw.directive.bbwFeedbackUnreadCount = ['bbw.FeedbackUnreadCountSvc', '$rootScope', function(feedbackUnreadCountSvc, $rootScope) {
    return {
        restrict: 'A',
        scope: {},
        replace: true,
        template: '<div class="unread-count" ng-show="unread.count">+<span class="unread-count--value">{{unread.count}}</span></div>',
        link: function(scope, element, attrs) {
            var initial = parseInt(attrs.bbwFeedbackUnreadCount || 0);
            scope.unread = {count: isNaN(initial) ? 0 : initial};
            feedbackUnreadCountSvc.subscribe(function(count) {
                var cb = function() {
                    scope.unread.count = count;
                };
                if ($rootScope.$$phase) {
                    scope.$evalAsync(cb);
                } else {
                    scope.$apply(cb);
                }
            }, scope);
        }
    };
}];
